import React from 'react';

import { emptyArray } from 'ui-components/default-props/empty';

import { SemiCircleBar } from './semi-circle-bar';
// @ts-expect-error less import
import style from './style.module.css';
import { summedPercentageValidator } from './validators';

/**
 * @typedef {import('./donut-chart-types.d.ts').DonutChartComponent} DonutChartComponent
 */

/**
 * @type {DonutChartComponent}
 */
export const DonutChart = ({ diameter = 200, barWidth = 10, sections = emptyArray }) => {
  summedPercentageValidator(sections);
  return (
    <div>
      <svg height={diameter / 2} width={diameter}>
        <SemiCircleBar barWidth={barWidth} className={style['background-circle']} diameter={diameter} percentage={100} />
        {sections.map((section, index) => {
          const alreadyDrawnPercentage = sections.slice(0, index).reduce((total, s) => total + s.percentage, 0);
          const nextPercentageToDraw = 100 - alreadyDrawnPercentage;
          const startingAngle = 180 * (nextPercentageToDraw / 100);

          return (
            <SemiCircleBar
              key={index}
              barWidth={barWidth}
              className={section.className}
              diameter={diameter}
              percentage={section.percentage}
              startingAngle={startingAngle}
            />
          );
        })}
      </svg>
    </div>
  );
};
